import React from 'react';

import FilterNavItems from './FilterNavItems';

/**
 * FilterNav
 *
 * Navigation links to category and imprint posts
 *
 * @param {Object} props
 * @param {Array} props.data
 * @param {Array} props.imprintData
 */
const FilterNav = ({ data }) => {

  const hasBrowseBy = data?.length > 0 && data?.some( ( item ) => item?.length > 0 );

  if ( !hasBrowseBy ) {
    return null;
  }

  // Sort the data by post type alphabetically
  const sortedData = data.sort( ( a, b ) => {
    if ( !a || !b ) return;
    const getPostType = ( items ) => items.map( post => post.post_type || post.type )
      .filter( ( v, i, arr ) => arr.indexOf( v ) === i )
      .toString().replace( 'book', '' );
    return getPostType( a ).localeCompare( getPostType( b ) );
  });

  return (
    <div className='filters__nav p-30 lg:p-0 lg:mb-40'>
      <h3 className='filters__heading text-14 text-[#606060] font-500 uppercase my-0'>Browse by:</h3>
      <ul className='filters__list list-none pl-0'>
        { sortedData.map( ( item, index ) => (
          item?.length > 0 ?
            <FilterNavItems
              key={ item[0]?.id || index }
              items={item}
            /> :
            null
        ) ) }
      </ul>
    </div>
  );
};

export default FilterNav;
